import lib from "zeta-dom";
const { createAutoCleanupMap, registerCleanup, watchAttributes, watchElements, watchOwnAttributes } = lib.dom;
export { createAutoCleanupMap, registerCleanup, watchAttributes, watchElements, watchOwnAttributes };